<template>
    <RegistrationStepPage step-name="payment">
        <card>
            <InvoiceRecipient v-if="!eventData.noInvoiceRecipient" />
            <Coupons
                v-if="chargeable"
                class="mt-4" />
            <PaymentType
                v-if="chargeable"
                class="mt-4" />
        </card>
    </RegistrationStepPage>
</template>

<script>
import InvoiceRecipient from "@/components/pages/registration/payment/InvoiceRecipient";
import PaymentType from "@/components/pages/registration/payment/PaymentType";
import Coupons from "@/components/pages/registration/payment/Coupons";
import registrationPriceMixin from "@/mixins/registration/registrationPriceMixin";
import RegistrationStepPage from '@/components/farbcode-core/Registration/RegistrationStepPage'

export default {
    name: "Payment",
    components: {Coupons, PaymentType, InvoiceRecipient, RegistrationStepPage},
    mixins: [registrationPriceMixin]
}
</script>

<style scoped>

</style>
